import stylex from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fonts.din2014Regular,
    padding: '0px',
  },
  headerContainer: {
    maxHeight: '64px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '24px',
  },
  header: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 24px',
    gap: anatomy['space-16'],
  },
  text: {
    fontSize: typography['fontSizeCaption-1'],
    color: colors.secondaryText,
  },
  btn: {
    display: 'flex',
    padding: '16px 24px',
    alignSelf: 'flex-end',
  },
  smsBlockLabel: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.secondaryText,
  },
});
export const filterStyles = stylex.create({
  sendInvite: {
    display: 'flex',
    padding: '0 24px 24px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  sendInviteText: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    color: colors.primaryText,
  },
  actionButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '28px',
    gap: '10px',
  },
});
